import React, { useState, useEffect, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import styled from "styled-components";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import LibraryAddCheckOutlinedIcon from "@mui/icons-material/LibraryAddCheckOutlined";

import dayjs from "dayjs";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import InputDialog from "../../components/InputDialog.js";
import EditInputDialog from "../../components/EditInputDialog.js";
import MultipleInputsDialog from "../../components/MultipleInputsDialog.js";
import publishImg from "../../assets/icons/publish.png";
import unpublishImg from "../../assets/icons/unpublish.png";
import copyImg from "../../assets/icons/copy.png";
import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import scoreImg from "../../assets/icons/score.png";
import previewImg from "../../assets/icons/preview.png";


import {
  FIND_FORM_FOR_CLIENT_QUERY,
  FORM_LIST_FOR_CLIENT_QUERY,
  CREATE_FORM_MUTATION,
  CHANGE_PUBLISH_STATUS_MUTATION,
  DELETE_FORM_MUTATION,
  COPY_FORM_MUTATION,
  SAVE_FORM_NAME_MUTATION
} from "../../graphQL/form_qry";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY } from "../../graphQL/component_qry";
import { TENANT_CLIENT_LIST_QUERY } from "../../graphQL/client_qry";
import {
  GET_CLIENT_DATA_BY_NAME,
  CREATE_CLIENT_MUTATION,
} from "../../graphQL/client_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledDateTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -45px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const StyledTooltipTerms = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "80px, -20px, 20px, -25px", //-75px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    background: #e2f2ff;
    color: #000;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    display: inline-flex;
    padding: 8px 20px 15px 20px;
    flex-direction: column;
    align-items: center;
  }
`;
const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function FormContainer() {
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [hoveredRowId, setHoveredRowId] = useState(null);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();
  const { handleSubmit } = useForm();
  const [publishStatus, setPublishStatus] = useState(false);
  const [alertMsg, setAlertMsg] = useState([]);
  const [alertCopyMsg, setAlertCopyMsg] = useState([]);
  const [alertPublishMsg, setAlertPublishMsg] = useState([]);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [alertTermMsg, setAlertTermMsg] = useState([]);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [inputDialogMsg, setInputDialogMsg] = useState([]);
  const [multipleInputsDialogMsg, setMultipleInputsDialogMsg] = useState([]);
  const [previewAlertMsg, setPreviewAlertMsg] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [failedMessage, setFailedMessage] = useState("");
  const [clientFormList, setClientFormList] = useState([]);
  const [allComponents, setAllComponents] = useState([]);
  const [tenantClientsList, setTenantClientsList] = useState([]);
  const [editInputDialogMsg, setEditInputDialogMsg] = useState([]);

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [publishAccess, setPublishAccess] = useState(false);
  const [assignScoresAccess, setAssignScoresAccess] = useState(false);
  const [previewAccess, setPreviewAccess] = useState(false);
  const [copyAccess, setCopyAccess] = useState(false);
  const [editedFormId, setEditedFormId] = useState(0);
  

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let clientId = 1;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");
  let tenantId = 1;
  if (localStorage.getItem("tenantId")) tenantId = localStorage.getItem("tenantId");

  let tenantName = "";
  if (localStorage.getItem("tenantName")) tenantName = localStorage.getItem("tenantName");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    let newFormat = "-";
    if (day) {
      const dayDate = new Date(day);
      const dayFormat = formatter.formatToParts(dayDate);
      newFormat =
        dayFormat.find(a => a.type == "month").value +
        "/" +
        dayFormat.find(a => a.type == "day").value +
        "/" +
        dayFormat.find(a => a.type == "year").value;
    }
    return newFormat;
  };

  const checkEditStatus = row => {
    if (row.status == "Published")
      setAlertMsg({
        title: "Edit Form",
        msg: 'The form "' + row.name + '" cannot be edited, because it is published.',
      });
    else navigate(`${project_url}/forms/${row.formUuid}`, {});
  };

  const [fetchForm] = useManualQuery(FIND_FORM_FOR_CLIENT_QUERY, {
    fetchPolicy: "network-only",
  });

  const [fetchClinetFormList] = useManualQuery(FORM_LIST_FOR_CLIENT_QUERY, {
    fetchPolicy: "network-only",
  });

  const [createForm] = useMutation(CREATE_FORM_MUTATION, {
    //refetchQueries: [{ query: FIND_FORM_FOR_CLIENT_QUERY }],
    awaitRefetchQueries: true,
  });

  const [saveFormName] = useMutation(SAVE_FORM_NAME_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [changePublishStatus] = useMutation(CHANGE_PUBLISH_STATUS_MUTATION, {
    fetchPolicy: "network-only",
  });

  const [deleteFormMutation] = useMutation(DELETE_FORM_MUTATION, {
    fetchPolicy: "network-only",
  });

  const [copyFormMutation] = useMutation(COPY_FORM_MUTATION, {
    fetchPolicy: "network-only",
  });

  const [fetchFormComponentsAnswers] = useManualQuery(
    GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const [fetchTenantClients] = useManualQuery(TENANT_CLIENT_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  const [createClient] = useMutation(CREATE_CLIENT_MUTATION, {
    //refetchQueries: [{ query: FIND_FORM_FOR_CLIENT_QUERY }],
    awaitRefetchQueries: true,
  });

  const [getClientData] = useManualQuery(GET_CLIENT_DATA_BY_NAME, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Forms",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      if(commonActions.find(a => a == "View"))
        setViewAccess(true)
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true)
      if(commonActions.find(a => a == "Edit"))
        setEditAccess(true)
      if(commonActions.find(a => a == "Delete"))
        setDeleteAccess(true)

      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');
      if(additionalActions.find(a => a == "Publish"))
        setPublishAccess(true)
      if(additionalActions.find(a => a == "Assign Scores"))
        setAssignScoresAccess(true)
      if(additionalActions.find(a => a == "Copy"))
        setCopyAccess(true)
      if(additionalActions.find(a => a == "Preview"))
        setPreviewAccess(true)

      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

  const getFormlist = async () => {
    const {
      loading: loadingClientForm,
      error: errorClientForm,
      data: dataClientForm,
    } = await fetchClinetFormList({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!loadingClientForm && dataClientForm && dataClientForm.formListForClient) {
      
      setClientFormList(dataClientForm.formListForClient);
    }
    if (errorClientForm) {
      if (errorClientForm.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
    }
  };

  const getTenantClients = async () => {
    const {
      loading: tenantClientsLoading,
      error: tenantClientsError,
      data: tenantClientsData,
    } = await fetchTenantClients();

    if (
      !tenantClientsLoading &&
      tenantClientsData &&
      tenantClientsData.tenantClientList
    ) {
      setTenantClientsList(tenantClientsData.tenantClientList);
    }
    if (tenantClientsError) {
      if (tenantClientsError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
    }
  };

  const previewForm = async formUuid => {
    if (formUuid) {
      const {
        loading: formComponentsAnswersLoading,
        error: formComponentsAnswersError,
        data: formComponentsAnswersData,
      } = await fetchFormComponentsAnswers({
        variables: { formUuid: formUuid },
      });

      if (
        !formComponentsAnswersLoading &&
        formComponentsAnswersData &&
        formComponentsAnswersData.formComponentAnswerList
      ) {
        setAllComponents(formComponentsAnswersData.formComponentAnswerList.componentList);
        if (
          formComponentsAnswersData.formComponentAnswerList.componentList.length !== 0
        ) {
          window.open(`${project_url}/forms/${formUuid}/preview`);
        } else {
          setPreviewAlertMsg({
            title: "Preview Form",
            msg: "This form has no object. Nothing to preview.",
          });
        }
      }
      if (
        formComponentsAnswersError &&
        formComponentsAnswersError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  function confirmCopyForm(row) {
    setAlertCopyMsg({
      title: "Copy Form",
      type: "copyConfirmation",
      msg: "Are you sure you want to copy the form “" + row.name + "”?",
      formId: row.id,
    });
  }

  function confirmPublishStatus(row, approved) {
    if (approved)
      setAlertPublishMsg({
        title: "Publish Form",
        type: "publishConfirmation",
        msg:
          "You are about to publish the form “" + row.name + "”. Do you wish to proceed?",
        formId: row.id,
        approved: approved,
      });
    else {
      if (row.terms == "")
        setAlertPublishMsg({
          title: "Unpublish Form",
          type: "publishConfirmation",
          msg:
            "You are about to unpublish the form “" +
            row.name +
            "”. Do you wish to proceed?",
          formId: row.id,
          approved: approved,
        });
      else
        setAlertMsg({
          title: "Unpublish Form",
          msg:
            "The form “" +
            row.name +
            "” cannot be unpublished, because it is used in the Term “" +
            row.terms.split(",")[0] +
            "”.",
        });
    }
  }

  function checkDeleteStatus(row) {
    if (row.terms == "")
      setAlertDeleteMsg({
        title: "Delete Form",
        type: "deleteConfirmation",
        msg: "Are you sure you want to delete the form “" + row.name + "”?",
        formId: row.id,
      });
    else
      setAlertDeleteMsg({
        title: "Delete Form",
        msg:
          "The form “" +
          row.name +
          "” cannot be deleted, because it is used in the Term “" +
          row.terms.split(",")[0] +
          "”.",
      });
  }

  function checkTermStatus(row) {
    setAlertTermMsg({
      title: 'Terms that use "' + row.name + '"',
      type: "termConfirmation",
      msg: row.termsObject.map(item => (
        <p>
          <a href={`${project_url}/terms/${item.termUuid}`}>{item.name}</a>
        </p>
      )),
    });
  }

  const updatePublishStatus = async (formId, approved) => {
    const {
      loading: loadingPublishStatus,
      error: errorPublishStatus,
      data: dataPublishStatus,
    } = await changePublishStatus({
      variables: {
        formId: parseInt(formId),
        approved: approved,
      },
    });
    if (
      !loadingPublishStatus &&
      dataPublishStatus &&
      dataPublishStatus.changePublishStatus
    ) {
      var formList = findAnd.changeProps(
        clientFormList,
        { formId: formId },
        {
          approved: dataPublishStatus.changePublishStatus.form.approved,
        }
      );
      setClientFormList(formList);
    }
    if (errorPublishStatus) {
      if (errorPublishStatus.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      else
        setAlertMsg({
          title: "Unpublish Form",
          msg: errorPublishStatus.graphQLErrors[0].message,
        });
    }
  };

  const deleteForm = async formId => {
    const {
      loading: loadingFormDelete,
      error: errorFormDelete,
      data: dataFormDelete,
    } = await deleteFormMutation({
      variables: {
        formId: parseInt(formId),
        clientId: parseInt(clientId),
      },
    });
    if (!loadingFormDelete && dataFormDelete && dataFormDelete.deleteForm) {
      setClientFormList(
        clientFormList.filter(form => parseInt(form.formId) !== parseInt(formId))
      );
    }
    if (errorFormDelete) {
      if (errorFormDelete.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      else
        setAlertMsg({
          title: "Delete Form",
          msg: errorFormDelete.graphQLErrors[0].message,
        });
    }
  };

  const handleEditFormName = (row) => { 
    setEditedFormId(row.id);

    setEditInputDialogMsg({ title: "Edit Form Name",
                            text: "",
                            msg: "Enter form name",
                            formName: row.name                            
                          })

  };

  const copyForm = async formId => {
    const {
      loading: loadingFormCopy,
      error: errorFormCopy,
      data: dataFormCopy,
    } = await copyFormMutation({
      variables: {
        formId: parseInt(formId),
      },
    });
    if (!loadingFormCopy && dataFormCopy && dataFormCopy.copyForm) {
      getFormlist();
    }
    if (errorFormCopy) {
      if (errorFormCopy.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      else
        setAlertCopyMsg({
          title: "Copy Form",
          msg: errorFormCopy.graphQLErrors[0].message,
        });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getFormlist())();
  }, []);

  useEffect(() => {
    (async () => getTenantClients())();
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 200,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        
        if (rows.row.editAccess) {

              return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  position: "relative",
                }}
                onMouseEnter={() => setHoveredRowId(rows.row.id)}
                onMouseLeave={() => setHoveredRowId(null)}
              >
                <span
                  style={{
                            cursor: 'pointer',
                            
                        }}
                  onClick={() => {
                            handleEditFormName(rows.row)
                          }}
                >
                          {rows.row.name}
                </span>
                  
               
                {hoveredRowId === rows.row.id && (
                  <StyledTooltip title="Edit this form name">
                        <img
                          style={{
                            paddingRight: 15,
                            cursor: 'pointer',
                            paddingTop: 6,
                            height: 19,
                            weight: 19,
                            filter: "none",
                            opacity: 1,
                          }}
                          src={penImg}
                          onClick={() => handleEditFormName(rows.row)}
                        />
                  </StyledTooltip>

                )}
              </div>
          )
            }
        else
        {
          return
          (
            <span>{rows.row.name}</span>
            ) 
        }
    }
    },

    {
      field: "dateCreated",
      headerName: "Date Created",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => (
        <StyledDateTooltip title={rows.row.createBy}>
          <span>{rows.row.dateCreated}</span>
        </StyledDateTooltip>
      ),
    },

    {
      field: "dateUpdated",
      headerName: "Date Updated",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => (
        <StyledDateTooltip title={rows.row.updateBy}>
          <span>{rows.row.dateUpdated}</span>
        </StyledDateTooltip>
      ),
    },

    {
      field: "noOfObjects",
      headerName: "No of Objects",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        let title = (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: 13,
                paddingBottom: 5,
                fontWeight: 600,
                letterSpacing: 0.46,
                textAlign: "center",
              }}
            >
              Terms List{" "}
            </div>
            {rows.row.termsObject.map(item => (
              <span style={{ paddingTop: 8 }}>
                <a href={`${project_url}/terms/${item.termUuid}`}>{item.name}</a>
              </span>
            ))}
          </div>
        );
        if (rows.row.status == "Published" && rows.row.terms !== "") {
          return (
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {rows.row.status}
              <StyledTooltipTerms interactive title={title}>
                <LibraryAddCheckOutlinedIcon
                  color="action"
                  style={{ marginLeft: 5, cursor: "pointer" }}
                />
              </StyledTooltipTerms>
            </Box>
          );
        } else return rows.row.status;
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 240,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";        
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;        
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";

        var publishFilter = rows.row.publishAccess ? "none" : "grayscale(1)";
        var publishOpacity = rows.row.publishAccess ? 1 : 0.5;        
        var publishCursor = rows.row.publishAccess ? "pointer" : "auto";

        var assignScoresFilter = rows.row.assignScoresAccess ? "none" : "grayscale(1)";
        var assignScoresOpacity = rows.row.assignScoresAccess ? 1 : 0.5;        
        var assignScoresCursor = rows.row.assignScoresAccess ? "pointer" : "auto";

        var copyFilter = rows.row.copyAccess ? "none" : "grayscale(1)";
        var copyOpacity = rows.row.copyAccess ? 1 : 0.5;        
        var copyCursor = rows.row.copyAccess ? "pointer" : "auto";

        var previewFilter = rows.row.previewAccess ? "none" : "grayscale(1)";
        var previewOpacity = rows.row.previewAccess ? 1 : 0.5;        
        var previewCursor = rows.row.previewAccess ? "pointer" : "auto";

        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >

            {rows.row.status === "Draft" ? (
              
                <StyledTooltip title="Publish this form">
                    <img
                      style={{
                        paddingRight: 15,
                        cursor: publishCursor,
                        paddingTop: 6,
                        height: 24,
                        weight: 24,
                        paddingTop: 6,
                        filter: publishFilter,
                        opacity: publishOpacity,
                      }}
                      src={publishImg}
                      onClick={() => rows.row.publishAccess ? confirmPublishStatus(rows.row, true): ""}
                    />
                </StyledTooltip>
                  
              
            ) : (

              <StyledTooltip title="Unpublish this form">
                      <img
                        style={{
                          paddingRight: 15,
                          cursor: publishCursor,
                          paddingTop: 6,
                          height: 24,
                          weight: 24,
                          paddingTop: 6,
                          filter: publishFilter,
                          opacity: publishOpacity,
                        }}
                        src={unpublishImg}
                        onClick={() => rows.row.publishAccess ? confirmPublishStatus(rows.row, false): ""}
                      />
              </StyledTooltip>
              
            )}

            <StyledTooltip title="Assign scores">
                  <img
                    style={{
                      paddingRight: 15,
                      cursor: assignScoresCursor,
                      height: 24,
                      weight: 24,
                      paddingTop: 6,
                      filter: assignScoresFilter,
                      opacity: assignScoresOpacity,
                    }}
                    src={scoreImg}
                    onClick={() => rows.row.assignScoresAccess ? navigate(`${project_url}/forms/${rows.row.formUuid}/assign-score`): ""}
                  />
            </StyledTooltip>
           
            <StyledTooltip title="Copy this form">
                  <img
                    style={{
                      paddingRight: 15,
                      cursor: copyCursor,
                      height: 24,
                      weight: 24,
                      paddingTop: 6,
                      filter: copyFilter,
                      opacity: copyOpacity,
                    }}
                    src={copyImg}
                    onClick={() => rows.row.copyAccess ?confirmCopyForm(rows.row): ""}
                  />
            </StyledTooltip>
            

            <StyledTooltip title="Preview">
                  <img
                    style={{
                      paddingRight: 15,
                      cursor: previewCursor,
                      height: 24,
                      weight: 24,
                      paddingTop: 6,
                      filter: previewFilter,
                      opacity: previewOpacity,
                    }}
                    src={previewImg}
                    onClick={() => rows.row.previewAccess ? previewForm(rows.row.formUuid): ""}
                  />
            </StyledTooltip>
            

            <StyledTooltip title="Edit this form">
                  <img
                    style={{
                      paddingRight: 15,
                      cursor: editCursor,
                      paddingTop: 6,
                      height: 24,
                      weight: 24,
                      filter: editFilter,
                      opacity: editOpacity,
                    }}
                    src={penImg}
                    onClick={() => rows.row.editAccess ?checkEditStatus(rows.row): ""}
                  />
            </StyledTooltip>
                      
           <StyledTooltip title="Delete this form">
                    <img
                      style={{
                        paddingRight: 15,
                        cursor: deleteCursor,
                        paddingTop: 6,
                        height: 24,
                        weight: 24,
                        filter: deleteFilter,
                        opacity: deleteOpacity,
                      }}
                      src={trashImg}
                      onClick={() => rows.row.deleteAccess ? checkDeleteStatus(rows.row): ""}
                    />
           </StyledTooltip>
           
           </Box>
        );
      },
    },
  ];

  var rows = clientFormList.map(frm => ({
    id: frm.formId,
    formUuid: frm.formUuid,
    name: frm.name,
    dateCreated: dayFormat(frm.createDate),
    noOfObjects: frm.noOfObjects,
    terms: frm.termList,
    termsObject: frm.termObjectList,
    status: frm.approved === false ? "Draft" : "Published",
    dateUpdated: dayFormat(frm.formObjsLastUpdate),
    createBy: frm.createBy, //.split(":")[1],
    updateBy: frm.formObjsLastUpdateBy, //.split(":")[1],
    editAccess : editAccess,
    deleteAccess: deleteAccess,
    publishAccess: publishAccess,
    assignScoresAccess: assignScoresAccess,
    previewAccess: previewAccess,
    copyAccess: copyAccess
  }));

  const saveForm = async formData => {
    let today = dayjs(new Date()).format("YYYY-MM-DD");

    //check if entered name exist in tenant or not
    const {
      loading: clientLoading,
      error: clientError,
      data: clientData,
    } = await getClientData({
      variables: {
        name: formData[0],
        tenantId: parseInt(tenantId),
        clientUuid: null,
      },
    });

    if (!clientLoading && clientData && clientData.getClientDataByName) {
      setAlertMsg({
        title: "Error",
        msg: "This client exists in the Tenant. Please enter another client name.",
      });
    } else {
      const { data: createClientData, error: createClientError } = await createClient({
        variables: {
          name: formData[0],
          tenantId: parseInt(tenantId),
          termStartDate: today.toString().slice(0, 10),
          termNoOfWeeks: 5,
        },
      });
      if (createClientError) {
        console.log("Error", createClientError, createClientData);
        // setAlertMsg({
        //   title: "Error",
        //   msg: "Unfortunately an error occurred.",
        // });
      } else if (createClientData && createClientData.createClient) {
        console.log("Success", createClientData);
        // setAlertMsg({
        //   title: "Success",
        //   msg: "New Client has been successfully added.",
        // });

        localStorage.setItem("clientId", createClientData.createClient.client.clientId);
        localStorage.setItem("clientName", createClientData.createClient.client.name);

        const { data, error } = await createForm({
          variables: {
            name: formData[1],
            clientId: parseInt(createClientData.createClient.client.clientId),
          },
        });
        if (error) {
          console.log("Error", error, data);
          // setFailedMessage("Unfortunately an error occurred.");
          // setTimeout("");
        } else if (data && data.createForm) {
          setAlertMsg({
            title: "Success",
            msg: "New Client and New Form has been successfully added.",
          });
          console.log("Success", data);
          localStorage.setItem("formName", formData[1]);
          navigate(`${project_url}/forms/${data.createForm.form.formUuid}`);
        }
      }
    }
  };
  /*
   * Function : onSubmit
   * Description : Submit form data
   */
  const onSubmit = async formName => {
    /*const {
        loading: formLoading,
        error: formError,
        data: formData,
      } = await fetchForm({
        variables: {
          clientId: parseInt(1),
          name: formName,
        },
      });

      if (!formLoading && formData && formData.findFormForClient) {
        alert(formData.findFormForClient)
      }*/

    const { data, error } = await createForm({
      variables: {
        name: formName,
        clientId: parseInt(clientId),
      },
    });
    if (error) {
      console.log("Error", error, data);
      setFailedMessage("Unfortunately an error occurred.");
      setTimeout("");
    } else if (data && data.createForm) {
      console.log("Success", data);

      navigate(`${project_url}/forms/${data.createForm.form.formUuid}`);
    }
  };
  
  /*
   * Function : updateFormName
   * Description : Submit form data
   */
  const updateFormName = async (formName) => { 
      
    if (formName.trim() != "") {
      const { data, error } = await saveFormName({
        variables: {
          name: formName,
          formId: parseInt(editedFormId),
        },
      });
      if (error) {
        console.log("Error", error, data);
        alert("Unfortunately an error occurred.");
      } else if (data && data.saveFormName) {
        console.log("Success", data);
        setEditInputDialogMsg([]);

        var formList = findAnd.changeProps(
        clientFormList,
        { formId: editedFormId },
        {
          name: formName,
        }
      );
      setClientFormList(formList);

        
      
      }
    } else alert("Please specify a name for your form.");
  };
  
  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Forms
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
                    variant="contained"
                    size="small"
                    className={classes.buttonStyle}
                    disabled = {!addAccess ? "disabled" : ""}
                    onClick={() =>
                      (addAccess ?
                      (
                          tenantClientsList.length
                            ? setInputDialogMsg({
                                title: "Form Name",
                                text: `This is a new form for Client: ${clientName}.`,
                                msg: "Enter form name",
                              })
                            : setMultipleInputsDialogMsg({
                                title: "Client & Form Names",
                                text:
                                  "You need to create a client before you can add a form." +
                                  " Please enter client name and form name." +
                                  " The client record will be created and the new form will be " +
                                  "assigned to it.",
                                msg: ["Enter client name", "Enter form name"],
                              })
                      )
                      : "")
                    }
                  >
                    Add
              </Button>
              
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  if (loadContent)
    if (access)
    return (
      <div className={classes.root}>
        <Header />
        <div className={classes.container}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.id}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              sorting: {
                sortModel: [{ field: "dateUpdated", sort: "desc" }],
              },
            }}
          />
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              type={alertMsg.type}
              contentMsg={alertMsg.msg}
              closeDialog={() => setAlertMsg([])}
              copyAction={() => {
                setAlertMsg([]);
                copyForm(alertMsg.formId);
              }}
            />
          )}
          {alertCopyMsg.msg && (
            <AlertDialog
              title={alertCopyMsg.title}
              type={alertCopyMsg.type}
              contentMsg={alertCopyMsg.msg}
              closeDialog={() => setAlertCopyMsg([])}
              copyAction={() => {
                setAlertCopyMsg([]);
                copyForm(alertCopyMsg.formId);
              }}
            />
          )}
          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteForm(alertDeleteMsg.formId);
              }}
            />
          )}
          {alertPublishMsg.msg && (
            <AlertDialog
              title={alertPublishMsg.title}
              type={alertPublishMsg.type}
              contentMsg={alertPublishMsg.msg}
              closeDialog={() => setAlertPublishMsg([])}
              publishAction={() => {
                setAlertPublishMsg([]);
                updatePublishStatus(alertPublishMsg.formId, alertPublishMsg.approved);
              }}
            />
          )}
          {inputDialogMsg.msg && (
            <InputDialog
              title={inputDialogMsg.title}
              text={inputDialogMsg.text}
              contentMsg={inputDialogMsg.msg}
              closeDialog={() => setInputDialogMsg([])}
              addDialog={value => {
                localStorage.setItem("formName", value);
                handleSubmit(onSubmit(value));
              }}
              errMsg="This is a required field"
              doneButton="Save Form"
            />
          )}
          {multipleInputsDialogMsg.msg && (
            <MultipleInputsDialog
              title={multipleInputsDialogMsg.title}
              text={multipleInputsDialogMsg.text}
              contentMsg={multipleInputsDialogMsg.msg}
              closeDialog={() => setMultipleInputsDialogMsg([])}
              addDialog={values => {
                handleSubmit(saveForm(values));
              }}
              errMsg="This is a required field"
              doneButton="Save Form"
            />
          )}

          {editInputDialogMsg.msg && (
            <EditInputDialog
              title={editInputDialogMsg.title}
              text={editInputDialogMsg.text}
              contentMsg={editInputDialogMsg.msg}
              formName={editInputDialogMsg.formName}
              closeDialog={() => setEditInputDialogMsg([])}
              editDialog={value => {
                handleSubmit(updateFormName(value));
              }}
              errMsg="This is a required field"
              doneButton="Save"
            />
          )}

          {previewAlertMsg.msg && (
            <AlertDialog
              title={previewAlertMsg.title}
              contentMsg={previewAlertMsg.msg}
              closeDialog={() => {
                setPreviewAlertMsg([]);
              }}
            />
          )}

          {alertTermMsg.msg && (
            <AlertDialog
              title={alertTermMsg.title}
              type={alertTermMsg.type}
              contentMsg={alertTermMsg.msg}
              closeDialog={() => setAlertTermMsg([])}
              termAction={() => {
                setAlertTermMsg([]);
              }}
            />
          )}
        </div>
      </div>
    );
    else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg="You do not have permission to access this page.Please navigate the system through the designed menu options on the sidebar menu"
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default FormContainer;
